// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"85":"mobile","524":"app","933":"auth"}[chunkId] || chunkId) + "." + {"85":"b32d9185","302":"ef5386c5","514":"aeed4a6a","523":"1ffe7e97","524":"e8e88074","933":"b76396d6"}[chunkId] + ".chunk.js";
};